module.exports = {
  CommercialRealEstateBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Commercial%20Real%20Estate%20Brochure.pdf",
  ContractorsBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Contractors%20Brochure.pdf",
  EnvironmentalBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Environmental%20Brochure.pdf",
  ExcessCasualtyBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Excess%20Casualty%20Brochure.pdf",
  HospitalityBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Hospitality%20Brochure.pdf",
  LessorsRiskBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Lessors%20Risk%20Brochure.pdf",
  ManufacturingBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Manufacturing%20Brochure.pdf",
  MonolinePropertyBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Monoline%20Property%20Brochure.pdf",
  OwnersInterestBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Owners%20Interest%20Brochure.pdf",
  RetailBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Retail%20Brochure.pdf",
  VacantBuildingsBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Mid-Market%20Industries%20and%20Products/ES-Vacant%20Buildings%20Brochure.pdf",
  ContractorsGLSmallBusinessBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Appetite%20Guide/Slice%20CGL%20App%20Guide%20for%20Small%20Business.pdf",
  ContractorsGLMidMarketBrochure:
    "https://1668259.fs1.hubspotusercontent-na1.net/hubfs/1668259/Appetite%20Guide/Slice%20CGL%20Mid-Market%20App%20Guide.pdf",
}
